import { ReactElement, useEffect, useState } from "react";

import { Box } from "@material-ui/core";

import {
  Create,
  CreateProps,
  useResourceDefinition,
  useResourceContext,
} from "react-admin";

import { CrudActionBreadcrumb, CrudActionType } from "../navigation";
import { usePermissionsCheck } from "../../core";
import { DefaultCreateAction } from "./actions";

const DefaultCreate = (
  props: CreateProps & { children: ReactElement }
): ReactElement => {
  const { options, icon } = useResourceDefinition(props);
  const { hasPermissionAccess, permissionsLoaded } = usePermissionsCheck();

  const resource = useResourceContext();
  const resourceName = options?.label;

  const {actions = <DefaultCreateAction/> } = props;
  const allowedPermissions = options?.allowedPermissions;
  const listPermissionName = allowedPermissions?.list;
  const createPermissionName = allowedPermissions?.create;
  const listPath = props?.basePath ? `${props?.basePath}` : `/${resource}`;

  const [hasList, setHasList] = useState(false);
  const [hasCreate, setHasCreate] = useState(false);

  useEffect(() => {
    if (permissionsLoaded) {
      const hasList = listPermissionName
      ? hasPermissionAccess(listPermissionName)
      : false;

      const hasCreate = createPermissionName
        ? hasPermissionAccess(createPermissionName)
        : false;

      setHasList(hasList);
      setHasCreate(hasCreate);
    }
  }, [
    permissionsLoaded,
    listPermissionName,
    createPermissionName,
    hasPermissionAccess,
  ]);

  const modifiedProps = {
    ...props,
    actions,
    hasList,
    hasCreate,
  };

  return (
    <Box>
      <Box pt={1}>
        <CrudActionBreadcrumb
          resourceLabel={resourceName}
          listPath={listPath}
          Icon={icon}
          actionType={CrudActionType.CREATE}
        />
      </Box>
      <Create {...modifiedProps} />
    </Box>
  );
};

export { DefaultCreate };
